import { useUserLegacy } from 'sierra-client/state/users/hooks'
import { UserId } from 'sierra-domain/api/uuid'

export const UserFirstName: React.FC<{ uuid: UserId }> = ({ uuid }) => {
  const user = useUserLegacy(uuid)

  if (user?.firstName === undefined) return null
  return <>{user.firstName}</>
}
